module.exports = __webpack_public_path__ + "img/partner_title.5babc4bd.png";